module.exports = __webpack_public_path__ + "02_glasses_black.4a955171.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer4/02_glasses_black.png
// module id = B6MO
// module chunks = 0